export default function decimalNumberFormatter(val) {
    if (!Number(val)) return 0;

    return val.toFixed(0);

}